import { Row } from "antd";
import { useMedia } from "use-media";
import React from "react";

import { Images } from "../../config";
import styles from "./style";

function LoginBox({ children, size = "large" }) {
  const isMobile = useMedia({ minWidth: "450px" });
  const isSmallMobile = useMedia({ minWidth: "350px" });
  return (
    <div style={styles.outerContainer}>
      <Row
        gutter={isMobile ? [50, 30] : [20, 0]}
        justify="center"
        style={{
          ...styles.container,
          ...{
            paddingTop: size === "small" ? "100px" : "80px",
            width: isMobile ? "450px" : isSmallMobile ? "360px" : "300px",
          },
        }}
      >
        <img
          src={Images.Logo}
          style={{
            ...styles.appIcon,
            ...{
              top:
                size === "small"
                  ? "-18%"
                  : isMobile
                  ? "-14%"
                  : isSmallMobile
                  ? "-14%"
                  : "-11%",
              left: isMobile ? "33%" : isSmallMobile ? "30%" : "30%",
            },
          }}
          alt=""
          width={isMobile ? 150 : isSmallMobile ? 130 : 110}
        />
        {children}
      </Row>
    </div>
  );
}

export default LoginBox;
